import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import { useMemo, type JSX } from "react";

import Adjustments from "@repo/icons/default/Adjustments";
import Clock from "@repo/icons/default/Clock";
import CreditCard from "@repo/icons/default/CreditCard";
import Door from "@repo/icons/default/Door";
import Left from "@repo/icons/default/Left";
import Notes from "@repo/icons/default/Notes";

import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { MenuList, type MenuListItem } from "@/components/ui/layout/menu/menu-list";
import { Page } from "@/components/ui/layout/page/page";

const menuItens: MenuListItem[] = [
  {
    name: "Agendas",
    Icon: Notes,
    route: "/settings/schedule-options/schedules",
  },
  {
    name: "Tipos de atendimento",
    Icon: Clock,
    route: "/settings/schedule-options/appointment-types",
  },
];

const SchedulesSettingsPage = (): JSX.Element => {
  const { flags } = useRouteContext({ from: "__root__" });

  const itemsToInclude = useMemo(() => {
    return flags["novos-items-na-tela-de-agenda"];
  }, [flags]);

  const getCompleteMenuItems = useMemo((): MenuListItem[] => {
    const items = [...menuItens];

    if (itemsToInclude.preferencias_atendimento) {
      items.push({
        name: "Preferências de atendimento",
        Icon: Adjustments,
        route: "/settings/schedule-options/service-preferences",
      });
    }

    if (itemsToInclude.salas_preferenciais) {
      items.push({
        name: "Salas preferenciais",
        Icon: Door,
        route: "/settings/schedule-options/preferred-rooms",
      });
    }
    items.push({
      name: "Convênios",
      Icon: CreditCard,
      route: "/settings/schedule-options/appointment-receiving-options",
    });

    return items;
  }, [itemsToInclude]);

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Configurações da agenda" />
      </HeaderRoot>
      <Page className="pt-2">
        <MenuList menuItems={getCompleteMenuItems} />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/schedule-options/")({
  component: SchedulesSettingsPage,
});
